import { Injectable } from '@angular/core';
import { INiveauDomaineEtudeResponse } from '../models/niveau-domaine-etude.model';
import { IMatiereResponse } from '../models/matiere.model';
import { HttpClient } from '@angular/common/http';
import { HTTP_OPTIONS, ROUTES } from '../constants';
import { Observable } from 'rxjs';
import { IDemandeList, IDemandeResponse } from '../models/demande.model';

@Injectable({
  providedIn: 'root'
})
export class ClassService {

  constructor(
    private httpClient: HttpClient
  ) { }

  /**
   * Add demande
   * @param body
   * @returns
   */
  create(body: IDemandeList): Observable<IDemandeResponse> {
    // try {
    return this.httpClient
      .post<IDemandeResponse>(
        `${ROUTES.demande.send}`,
        body,
        HTTP_OPTIONS
      );
  }

  /**
   * Get all niveau domaine etudes
   * @returns
  */
  getClass(): Observable<INiveauDomaineEtudeResponse> {
    console.log(ROUTES.demande.classes);

    return this.httpClient
      .get<INiveauDomaineEtudeResponse>(`${ROUTES.demande.classes}`);
  }
  
  /**
   * Get all matieres
   * @returns
   */
  getMatieres(): Observable<IMatiereResponse> {
    return this.httpClient
      .get<IMatiereResponse>(`${ROUTES.demande.matieres}`);
  }
}
